import type { NamePool } from "@/core/types.js";

export const auNamePool: NamePool = {
  given: {
    male: [
      "Oliver", "William", "Jack", "Noah", "Thomas", "James", "Lucas",
      "Henry", "Ethan", "Mason", "Alexander", "Charlie", "Liam", "Lachlan",
      "Joshua", "Benjamin", "Samuel", "Cooper", "Elijah", "Isaac",
      "Riley", "Hudson", "Angus", "Flynn", "Hamish", "Sebastian",
      "Harrison", "Finn", "Archie", "Max", "Leo", "Jake",
    ],
    female: [
      "Olivia", "Charlotte", "Ava", "Amelia", "Mia", "Isla", "Grace",
      "Sophie", "Ella", "Emma", "Chloe", "Isabella", "Ruby", "Zoe",
      "Lily", "Emily", "Harper", "Layla", "Aria", "Evie",
      "Madison", "Ellie", "Sofia", "Scarlett", "Sienna", "Freya",
      "Matilda", "Abigail", "Hannah", "Imogen", "Ivy", "Aurora",
    ],
  },
  family: [
    "Smith", "Jones", "Williams", "Brown", "Wilson", "Taylor", "Johnson",
    "White", "Martin", "Anderson", "Thompson", "Nguyen", "Thomas", "Walker",
    "Harris", "Lee", "Ryan", "Robinson", "Kelly", "King",
    "Davis", "Wright", "Evans", "Roberts", "Green", "Hall", "Young",
    "Clarke", "Mitchell", "Lewis", "Scott", "Watson", "Morrison",
    "O'Brien", "Sullivan", "Murphy", "Walsh", "Patel", "Singh", "Chen",
    "Miller", "Cooper", "Campbell", "Stewart", "Baker", "Turner",
    "Hill", "Collins", "Wood", "Parker",
  ],
};
